import * as Yup from 'yup'

export const validationSchema = (maxRewards: number) =>
  Yup.object({
    internalName: Yup.string().required('Required'),
    displayName: Yup.string().required('Required'),
    description: Yup.string().required('Required'),
    bonusRewardConfiguration: Yup.object().nullable(),
    displayOrder: Yup.number()
      .min(1, `Display order must be between 1 and ${maxRewards}`)
      .required('Required')
      .max(maxRewards, `Display order must be between 1 and ${maxRewards}`),
    startDate: Yup.string().required('Required'),
    endDate: Yup.string().required('Required'),
    lastModified: Yup.string().required('Required'),
    tiers: Yup.array().of(
      Yup.object({
        name: Yup.string().required('Tier name is required'),
        reward: Yup.object({
          id: Yup.string().required('Reward is required'),
        }),
        trackingMetric: Yup.object({
          id: Yup.number()
            .transform((value) => (isNaN(value) ? undefined : value))
            .required('Reward Tracking Metric is required'),
        }),
        rewardProgramTierConditionLogic: Yup.object({
          id: Yup.number()
            .transform((value) => (isNaN(value) ? undefined : value))
            .required('Reward Program Tier Condition is required'),
        }),
        callToActionText: Yup.string().required(),
        metrics: Yup.array().of(
          Yup.object({
            rewardProgramTierLogicalOperator: Yup.object({
              id: Yup.number()
                .transform((value) => (isNaN(value) ? undefined : value))
                .required('AND/OR operator is required'),
            }).required(),

            trackingMetric: Yup.object({
              id: Yup.number()
                .transform((value) => (isNaN(value) ? undefined : value))
                .required('Reward Tracking Metric is required'),
            }),
            rewardProgramTierConditionLogic: Yup.object({
              id: Yup.number()
                .transform((value) => (isNaN(value) ? undefined : value))
                .required('Reward Program Tier Condition is required'),
            }),
            value: Yup.number().min(1, 'threshold value is required').required(),
          })
        ),
      })
    ),
  })
